// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart[data-v-2547b00f]{margin:0 auto;max-width:1000px}", ""]);
// Exports
module.exports = exports;
